import { useMonarchRule } from "../MonarchRulesProvider";
import type {
  AuthxLogistrationSplitData,
  AuthxLogistrationSplitVariant,
  UseAuthxLogistrationSplit,
} from "./types";
import { StartAsPage } from "@/app/[locale]/auth/login/components/types";

const CUSTOM_RULE_ID = "authxLogistrationSplit";

const defaultData: AuthxLogistrationSplitData = {
  redirectLoginToAuthx: false,
  redirectRegisterToAuthx: false,
};

const useAuthxLogistrationSplit: UseAuthxLogistrationSplit = (
  startAs: StartAsPage,
): {
  isLoading: boolean;
  variant: AuthxLogistrationSplitVariant;
  data: AuthxLogistrationSplitData;
} => {
  const { isLoading, value } = useMonarchRule<AuthxLogistrationSplitData>(
    CUSTOM_RULE_ID,
    {},
  );

  if (isLoading) {
    return {
      isLoading,
      variant: "control",
      data: defaultData,
    };
  }

  const data = value ?? defaultData;

  // Backward compatibility: if new fields don't exist, fall back to legacy field
  let shouldRedirect: boolean;

  if (startAs === StartAsPage.Login) {
    shouldRedirect = data.redirectLoginToAuthx ?? data.redirectToAuthx ?? false;
  } else {
    shouldRedirect =
      data.redirectRegisterToAuthx ?? data.redirectToAuthx ?? false;
  }

  const variant: AuthxLogistrationSplitVariant = shouldRedirect
    ? "authx"
    : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useAuthxLogistrationSplit;
